// extracted by mini-css-extract-plugin
module.exports = {"inputs":"createAccountForm-module__inputs___frMcp","formError":"createAccountForm-module__formError___1KbCC","nextButton":"createAccountForm-module__nextButton___bNGWZ"};